// src/data/planetImages.js
const planetImageMap = {
  "tatooine": "tatooine",
  "alderaan": "alderaan",
  "yavin iv": "yavin4",
  "hoth": "hoth",
  "dagobah": "dagobah",
  "bespin": "bespin",
  "endor": "endor",
  "naboo": "naboo",
  "coruscant": "coruscant",
  "kamino": "kamino",
  "geonosis": "geonosis",
  "utapau": "utapau",
  "mustafar": "mustafar",
  "kashyyyk": "kashyyyk",
  "polis massa": "polismassa",
  "mygeeto": "mygeeto",
  "felucia": "felucia",
  "cato neimoidia": "catoneimoidia",
  "saleucami": "saleucami",
  "stewjon": "stewjon",
  "eriadu": "eriadu",
  "corellia": "corellia",
  "rodia": "rodia",
  "nal hutta": "nalhutta",
  "dantooine": "dantooine",
  "bestine iv": "bestine4",
  "ord mantell": "ordmantell",
  "trandosha": "trandosha",
  "socorro": "socorro",
  "mon cala": "moncala",
  "chandrila": "chandrila",
  "sullust": "sullust",
  "toydaria": "toydaria",
  "malastare": "malastare",
  "dathomir": "dathomir",
  "ryloth": "ryloth",
  "aleen minor": "aleenminor",
  "vulpter": "vulpter",
  "troiken": "troiken",
  "tund": "tund",
  "haruun kal": "haruunkal",
  "cerea": "cerea",
  "glee anselm": "gleeanselm",
  "iridonia": "iridonia",
  "tholoth": "tholoth",
  "iktotch": "iktotch",
  "quermia": "quermia",
  "dorin": "dorin",
  "champala": "champala",
  "mirial": "mirial",
  "serenno": "serenno",
  "concord dawn": "concorddawn",
  "zolan": "zolan",
  "ojom": "ojom",
  "skako": "skako",
  "muunilinst": "muunilinst",
  "shili": "shili",
  "kalee": "kalee",
  "umbara": "umbara",
};

export default planetImageMap;